/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosAccountInfo } from '../models/AptosAccountInfo';
import type { AptosAddressActivityListInfo } from '../models/AptosAddressActivityListInfo';
import type { AptosAddressCoinListInfo } from '../models/AptosAddressCoinListInfo';
import type { AptosAddressDetailInfo } from '../models/AptosAddressDetailInfo';
import type { AptosAddressDetailRequest } from '../models/AptosAddressDetailRequest';
import type { AptosAddressListInfo } from '../models/AptosAddressListInfo';
import type { AptosAddressListRequest } from '../models/AptosAddressListRequest';
import type { AptosAddressModuleInfo } from '../models/AptosAddressModuleInfo';
import type { AptosAddressNftListInfo } from '../models/AptosAddressNftListInfo';
import type { AptosAddressNftListRequest } from '../models/AptosAddressNftListRequest';
import type { AptosAddressPageableRequest } from '../models/AptosAddressPageableRequest';
import type { AptosAddressPortfolioCoinListInfo } from '../models/AptosAddressPortfolioCoinListInfo';
import type { AptosAddressTopSummaryListRequest } from '../models/AptosAddressTopSummaryListRequest';
import type { AptosAddressTotalCountInfo } from '../models/AptosAddressTotalCountInfo';
import type { AptosBalanceRankInfo } from '../models/AptosBalanceRankInfo';
import type { AptosCoinTransferListInfo } from '../models/AptosCoinTransferListInfo';
import type { AptosTopAddressSummaryListInfo } from '../models/AptosTopAddressSummaryListInfo';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';
import type { AptosUawAddressCountChartListInfo } from '../models/AptosUawAddressCountChartListInfo';
import type { BabylonActiveUserCountInfo } from '../models/BabylonActiveUserCountInfo';
import type { BabylonActiveUserRequest } from '../models/BabylonActiveUserRequest';
import type { BabylonAddressBtcStakerSummary } from '../models/BabylonAddressBtcStakerSummary';
import type { BabylonAddressDetailInfo } from '../models/BabylonAddressDetailInfo';
import type { BabylonAddressDetailRequest } from '../models/BabylonAddressDetailRequest';
import type { BabylonAddressListInfo } from '../models/BabylonAddressListInfo';
import type { BabylonAddressPortfolioListRequest } from '../models/BabylonAddressPortfolioListRequest';
import type { BabylonAddressPortfolioTokenListInfo } from '../models/BabylonAddressPortfolioTokenListInfo';
import type { BabylonAddressRequest } from '../models/BabylonAddressRequest';
import type { BabylonAddressStakingRequest } from '../models/BabylonAddressStakingRequest';
import type { BabylonBtcStakerListInfo } from '../models/BabylonBtcStakerListInfo';
import type { BabylonBtcStakerListRequest } from '../models/BabylonBtcStakerListRequest';
import type { BabylonBtcStakingOverviewListInfo } from '../models/BabylonBtcStakingOverviewListInfo';
import type { BabylonBtcStakingOverviewRequest } from '../models/BabylonBtcStakingOverviewRequest';
import type { BabylonBtcStakingTransactionListInfo } from '../models/BabylonBtcStakingTransactionListInfo';
import type { BabylonTransactionListByAddressRequest } from '../models/BabylonTransactionListByAddressRequest';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmAddressDetailInfo } from '../models/EvmAddressDetailInfo';
import type { EvmAddressDetailRequest } from '../models/EvmAddressDetailRequest';
import type { EvmAddressListInfo } from '../models/EvmAddressListInfo';
import type { EvmAddressListRequest } from '../models/EvmAddressListRequest';
import type { EvmAddressPageableRequest } from '../models/EvmAddressPageableRequest';
import type { EvmAddressTokenTrxListRequest } from '../models/EvmAddressTokenTrxListRequest';
import type { EvmContractCodeInfo } from '../models/EvmContractCodeInfo';
import type { EvmDeployContractListInfo } from '../models/EvmDeployContractListInfo';
import type { EvmInternalTrxListInfo } from '../models/EvmInternalTrxListInfo';
import type { EvmTokenListInfo } from '../models/EvmTokenListInfo';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';
import type { HumanityAddressDetailInfo } from '../models/HumanityAddressDetailInfo';
import type { HumanityAddressDetailRequest } from '../models/HumanityAddressDetailRequest';
import type { HumanityAddressListInfo } from '../models/HumanityAddressListInfo';
import type { HumanityAddressListRequest } from '../models/HumanityAddressListRequest';
import type { HumanityAddressPageableRequest } from '../models/HumanityAddressPageableRequest';
import type { HumanityAddressTokenListInfo } from '../models/HumanityAddressTokenListInfo';
import type { HumanityAddressTokenTrxListRequest } from '../models/HumanityAddressTokenTrxListRequest';
import type { HumanityContractCodeInfo } from '../models/HumanityContractCodeInfo';
import type { HumanityDeployContractListInfo } from '../models/HumanityDeployContractListInfo';
import type { HumanityInternalTrxListInfo } from '../models/HumanityInternalTrxListInfo';
import type { HumanityTrxListInfo } from '../models/HumanityTrxListInfo';
import type { KiteAddressDetailInfo } from '../models/KiteAddressDetailInfo';
import type { KiteAddressDetailRequest } from '../models/KiteAddressDetailRequest';
import type { KiteAddressListInfo } from '../models/KiteAddressListInfo';
import type { KiteAddressListRequest } from '../models/KiteAddressListRequest';
import type { KiteAddressNftTransferListRequest } from '../models/KiteAddressNftTransferListRequest';
import type { KiteAddressPageableRequest } from '../models/KiteAddressPageableRequest';
import type { KiteAddressTokenListInfo } from '../models/KiteAddressTokenListInfo';
import type { KiteAddressTokenTransferListRequest } from '../models/KiteAddressTokenTransferListRequest';
import type { KiteAddressTokenTrxListRequest } from '../models/KiteAddressTokenTrxListRequest';
import type { KiteContractCodeInfo } from '../models/KiteContractCodeInfo';
import type { KiteDeployContractListInfo } from '../models/KiteDeployContractListInfo';
import type { KiteInternalTrxListInfo } from '../models/KiteInternalTrxListInfo';
import type { KiteTrxListInfo } from '../models/KiteTrxListInfo';
import type { KiteTrxNftTransferListInfo } from '../models/KiteTrxNftTransferListInfo';
import type { KiteTrxTokenTransferListInfo } from '../models/KiteTrxTokenTransferListInfo';
import type { NexonAddressNftTransferListRequest } from '../models/NexonAddressNftTransferListRequest';
import type { NexonAddressTokenTransferListRequest } from '../models/NexonAddressTokenTransferListRequest';
import type { NexonTrxNftTransferListInfo } from '../models/NexonTrxNftTransferListInfo';
import type { NexonTrxTokenTransferListInfo } from '../models/NexonTrxTokenTransferListInfo';
import type { SomniaAccountPortfolioNftListInfo } from '../models/SomniaAccountPortfolioNftListInfo';
import type { SomniaAccountPortfolioTokenListInfo } from '../models/SomniaAccountPortfolioTokenListInfo';
import type { SomniaAddressDetailInfo } from '../models/SomniaAddressDetailInfo';
import type { SomniaAddressDetailRequest } from '../models/SomniaAddressDetailRequest';
import type { SomniaAddressListInfo } from '../models/SomniaAddressListInfo';
import type { SomniaAddressListRequest } from '../models/SomniaAddressListRequest';
import type { SomniaAddressNftTransferListRequest } from '../models/SomniaAddressNftTransferListRequest';
import type { SomniaAddressPageableRequest } from '../models/SomniaAddressPageableRequest';
import type { SomniaAddressTokenTransferListRequest } from '../models/SomniaAddressTokenTransferListRequest';
import type { SomniaInternalTrxListInfo } from '../models/SomniaInternalTrxListInfo';
import type { SomniaTrxListInfo } from '../models/SomniaTrxListInfo';
import type { SomniaTrxNftTransferListInfo } from '../models/SomniaTrxNftTransferListInfo';
import type { SomniaTrxTokenTransferListInfo } from '../models/SomniaTrxTokenTransferListInfo';
import type { ZerogAddressDelegationOverviewInfo } from '../models/ZerogAddressDelegationOverviewInfo';
import type { ZerogAddressDelegationOverviewRequest } from '../models/ZerogAddressDelegationOverviewRequest';
import type { ZerogAddressDetailInfo } from '../models/ZerogAddressDetailInfo';
import type { ZerogAddressDetailRequest } from '../models/ZerogAddressDetailRequest';
import type { ZerogAddressListInfo } from '../models/ZerogAddressListInfo';
import type { ZerogAddressListRequest } from '../models/ZerogAddressListRequest';
import type { ZerogAddressNftPortfolioListInfo } from '../models/ZerogAddressNftPortfolioListInfo';
import type { ZerogAddressNftPortfolioListRequest } from '../models/ZerogAddressNftPortfolioListRequest';
import type { ZerogAddressPageableRequest } from '../models/ZerogAddressPageableRequest';
import type { ZerogAddressTokenListInfo } from '../models/ZerogAddressTokenListInfo';
import type { ZerogAddressTokenPortfolioListInfo } from '../models/ZerogAddressTokenPortfolioListInfo';
import type { ZerogAddressTokenPortfolioListRequest } from '../models/ZerogAddressTokenPortfolioListRequest';
import type { ZerogAddressTokenTrxListRequest } from '../models/ZerogAddressTokenTrxListRequest';
import type { ZerogContractCodeInfo } from '../models/ZerogContractCodeInfo';
import type { ZerogInternalTrxListInfo } from '../models/ZerogInternalTrxListInfo';
import type { ZerogTrxListInfo } from '../models/ZerogTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AddressControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressDetail({
        requestBody,
    }: {
        requestBody: (AptosAddressDetailRequest | EvmAddressDetailRequest | HumanityAddressDetailRequest | KiteAddressDetailRequest | BabylonAddressDetailRequest | SomniaAddressDetailRequest | ZerogAddressDetailRequest),
    }): CancelablePromise<(AptosAddressDetailInfo | EvmAddressDetailInfo | HumanityAddressDetailInfo | KiteAddressDetailInfo | BabylonAddressDetailInfo | SomniaAddressDetailInfo | ZerogAddressDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getUawAddressCount({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<AptosUawAddressCountChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/uaw/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTransferList1({
        requestBody,
    }: {
        requestBody: (AptosAddressPageableRequest | ZerogAddressTokenTrxListRequest),
    }): CancelablePromise<(AptosCoinTransferListInfo | ZerogAddressTokenListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenTransactionTokenList({
        requestBody,
    }: {
        requestBody: (EvmAddressTokenTrxListRequest | HumanityAddressTokenTrxListRequest | KiteAddressTokenTrxListRequest | ZerogAddressTokenTrxListRequest),
    }): CancelablePromise<(EvmTokenListInfo | HumanityAddressTokenListInfo | KiteAddressTokenListInfo | ZerogAddressTokenListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/transaction/token/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTransactionList1({
        requestBody,
    }: {
        requestBody: (AptosAddressPageableRequest | EvmAddressPageableRequest | HumanityAddressPageableRequest | KiteAddressPageableRequest | BabylonTransactionListByAddressRequest | SomniaAddressPageableRequest | ZerogAddressPageableRequest),
    }): CancelablePromise<(AptosTrxListInfo | EvmTrxListInfo | HumanityTrxListInfo | KiteTrxListInfo | BabylonTrxListInfo | SomniaTrxListInfo | ZerogTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTransactionList({
        requestBody,
    }: {
        requestBody: (EvmAddressPageableRequest | HumanityAddressPageableRequest | KiteAddressPageableRequest | SomniaAddressPageableRequest | ZerogAddressPageableRequest),
    }): CancelablePromise<(EvmInternalTrxListInfo | HumanityInternalTrxListInfo | KiteInternalTrxListInfo | SomniaInternalTrxListInfo | ZerogInternalTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/transaction/internal/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressTotalCount({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<AptosAddressTotalCountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/totalcount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTopAddressSummary({
        requestBody,
    }: {
        requestBody: AptosAddressTopSummaryListRequest,
    }): CancelablePromise<AptosTopAddressSummaryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/top/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenTransferList2({
        requestBody,
    }: {
        requestBody: (SomniaAddressTokenTransferListRequest | KiteAddressTokenTransferListRequest | NexonAddressTokenTransferListRequest),
    }): CancelablePromise<(SomniaTrxTokenTransferListInfo | KiteTrxTokenTransferListInfo | NexonTrxTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressResourceList({
        requestBody,
    }: {
        requestBody: AptosAddressDetailRequest,
    }): CancelablePromise<Array<AptosAddressCoinListInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/resource/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPortfolioTokenList({
        requestBody,
    }: {
        requestBody: (BabylonAddressPortfolioListRequest | ZerogAddressTokenPortfolioListRequest | SomniaAddressPageableRequest),
    }): CancelablePromise<(BabylonAddressPortfolioTokenListInfo | ZerogAddressTokenPortfolioListInfo | SomniaAccountPortfolioTokenListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/portfolio/token/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressNftV2List({
        requestBody,
    }: {
        requestBody: AptosAddressNftListRequest,
    }): CancelablePromise<AptosAddressNftListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/portfolio/nft/v2/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressNftV1List({
        requestBody,
    }: {
        requestBody: (AptosAddressNftListRequest | ZerogAddressNftPortfolioListRequest | SomniaAddressPageableRequest),
    }): CancelablePromise<(AptosAddressNftListInfo | ZerogAddressNftPortfolioListInfo | SomniaAccountPortfolioNftListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/portfolio/nft/v1/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPortfolioFungibleAssetList({
        requestBody,
    }: {
        requestBody: AptosAddressPageableRequest,
    }): CancelablePromise<AptosAddressPortfolioCoinListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/portfolio/fa/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPortfolioCoinList({
        requestBody,
    }: {
        requestBody: AptosAddressPageableRequest,
    }): CancelablePromise<AptosAddressPortfolioCoinListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/portfolio/coin/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftTransferList1({
        requestBody,
    }: {
        requestBody: (AptosAddressPageableRequest | SomniaAddressNftTransferListRequest | KiteAddressNftTransferListRequest | NexonAddressNftTransferListRequest),
    }): CancelablePromise<(AptosAddressActivityListInfo | SomniaTrxNftTransferListInfo | KiteTrxNftTransferListInfo | NexonTrxNftTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/nft/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftTransferList2({
        requestBody,
    }: {
        requestBody: (AptosAddressPageableRequest | SomniaAddressNftTransferListRequest | KiteAddressNftTransferListRequest | NexonAddressNftTransferListRequest),
    }): CancelablePromise<(AptosAddressActivityListInfo | SomniaTrxNftTransferListInfo | KiteTrxNftTransferListInfo | NexonTrxNftTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/nft/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressModuleList({
        requestBody,
    }: {
        requestBody: AptosAddressDetailRequest,
    }): CancelablePromise<Array<AptosAddressModuleInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/module/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressList1({
        requestBody,
    }: {
        requestBody: (AptosAddressListRequest | EvmAddressListRequest | HumanityAddressListRequest | KiteAddressListRequest | BabylonAddressRequest | SomniaAddressListRequest | ZerogAddressListRequest),
    }): CancelablePromise<(AptosAddressListInfo | EvmAddressListInfo | HumanityAddressListInfo | KiteAddressListInfo | BabylonAddressListInfo | SomniaAddressListInfo | ZerogAddressListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAccountInfo({
        requestBody,
    }: {
        requestBody: AptosAddressDetailRequest,
    }): CancelablePromise<AptosAccountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegationOverview({
        requestBody,
    }: {
        requestBody: ZerogAddressDelegationOverviewRequest,
    }): CancelablePromise<ZerogAddressDelegationOverviewInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/delegation/overview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractCode({
        requestBody,
    }: {
        requestBody: (EvmAddressDetailRequest | HumanityAddressDetailRequest | KiteAddressDetailRequest | ZerogAddressDetailRequest),
    }): CancelablePromise<(EvmContractCodeInfo | HumanityContractCodeInfo | KiteContractCodeInfo | ZerogContractCodeInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/contract/code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getContractCodeList1({
        requestBody,
    }: {
        requestBody: (EvmAddressListRequest | HumanityAddressListRequest | KiteAddressListRequest | ZerogAddressListRequest),
    }): CancelablePromise<(EvmDeployContractListInfo | HumanityDeployContractListInfo | KiteDeployContractListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/contract/code/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressCoinList({
        requestBody,
    }: {
        requestBody: AptosAddressListRequest,
    }): CancelablePromise<AptosAddressCoinListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/coin/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingTransactionListByAddress({
        requestBody,
    }: {
        requestBody: BabylonAddressStakingRequest,
    }): CancelablePromise<BabylonBtcStakingTransactionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/btc/staking/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakerSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonAddressBtcStakerSummary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/btc/staking/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingOverviewListByAddress({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingOverviewRequest,
    }): CancelablePromise<BabylonBtcStakingOverviewListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/btc/staking/overview/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakerList({
        requestBody,
    }: {
        requestBody: BabylonBtcStakerListRequest,
    }): CancelablePromise<BabylonBtcStakerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/btc/staking/address/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRankByBalance({
        requestBody,
    }: {
        requestBody: AptosAddressDetailRequest,
    }): CancelablePromise<AptosBalanceRankInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/balance/rank',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBabylonActiveUserCount({
        requestBody,
    }: {
        requestBody: BabylonActiveUserRequest,
    }): CancelablePromise<BabylonActiveUserCountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/active',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
